import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';

export const logout = (services: CommandServices) => {
  return createCommand('logout')
    .description('Log out of your Wix account')
    .action(async (_, command) => {
      const { getUserInfo } = await import('@wix/cli-auth');
      const { LogoutCommand } = await import(
        '../components/LogoutCommand/index.js'
      );
      const { renderCommand } = await import('./render-command.js');

      const userInfo = await getUserInfo();

      await renderCommand(
        command,
        services,
        <LogoutCommand userInfo={userInfo} />
      );
    });
};
